import styled from 'styled-components';
import MenuItem from '@mui/material/MenuItem';
import { ReactComponent as ArrowDownIcon } from '../../assets/icons/icon-arrow-down.svg';
import AppCSS from '../../utils/styled';
import { DEFAULT_BUTTON_WIDTH, HEADER_BUTTON_HEIGHT } from '../../utils/styled/dimensions';

export const Components = {
  Layout: styled.div`
    display: flex;
    height: 100%;
    width: 100%;
    overflow: hidden;
    background-color: ${AppCSS.colors.utility.screenBackground};
  `,
  Container: styled.div`
    flex: 1;
    min-width: 0;
    height: 100%;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    padding: 16px 24px;
    background-color: ${AppCSS.colors.utility.screenBackground};
    gap: 32px;
    overflow-x: auto;
  `,
  ComponentContainer: styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-items: flex-start;
    width: 100%;
    min-width: fit-content;
    gap: 32px;
  `,
  TableWrapper: styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    ${AppCSS.boxShadows.block};
  `,
  SearchBarChildrenWrapper: styled.div`
    display: flex;
    align-items: flex-end;
    justify-content: center;
    gap: 24px;
    margin-left: 8px;
    height: 100%;
  `,
  SearchBarSeparator: styled.div`
    width: 1px;
    height: 38px;
    background-color: ${AppCSS.colors.greys.light};
  `,
  FiltersWrapper: styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
  `,

  PrimaryButton: styled(AppCSS.buttonStyles.PrimaryButtonStyle)`
    width: ${DEFAULT_BUTTON_WIDTH}px;
    min-width: ${DEFAULT_BUTTON_WIDTH}px;
    height: ${HEADER_BUTTON_HEIGHT}px;
    min-height: ${HEADER_BUTTON_HEIGHT}px;
  `,

  MenuItem: styled(MenuItem)`
    padding: 8px;
    ${AppCSS.fonts.label12Regular};
    color: ${AppCSS.colors.black};
  `,
  Picker: styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 8px;
    cursor: pointer;
    ${AppCSS.radiuses.small};
    border: 1px solid ${AppCSS.colors.greys.medium};
    background-color: transparent;
    overflow: hidden;
    width: 20%;
    padding: 12px;
  `,
  PickerIconWrapper: styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 16px;
    height: 16px;
  `,
  PickerLabel: styled.span`
    flex: 1;
    ${AppCSS.fonts.label12Medium};
    color: ${AppCSS.colors.blues.veryDark};
  `,
  PickerIcon: styled(ArrowDownIcon)`
    height: 16px;
    width: 16px;
  `,
  NotSetLabel: styled.span`
    ${AppCSS.fonts.label12Medium};
    color: ${AppCSS.colors.black};
    flex: 1;
  `,

  LengthInputsWrapper: styled.div`
    width: 100%;
    display: flex;
    align-items: flex-start;
    justify-content: center;
    gap: 8px;
  `,
  PillarTableWrapper: styled.div`
    height: 100%;
    width: 100%;
    background-color: ${AppCSS.colors.white};
  `,

  SectionHeader: styled.span`
    ${AppCSS.fonts.h3};
    color: ${AppCSS.colors.blues.veryDark};
  `,
  SectionDescription: styled.span`
    ${AppCSS.fonts.label14Regular};
    color: ${AppCSS.colors.greys.medium};
  `,
  SectionHeaderWrapper: styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    gap: 4px;
    padding-top: 8px;
  `,
};
